import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AppConfig } from 'src/app/config/app-config';
import { AppConfigService } from 'src/app/config/app-config.service';

@Injectable({
  providedIn: 'root',
})
export class BomCookieService {
  appConfig: AppConfig;

  constructor(private appConfigService: AppConfigService, private cookieService: CookieService) {}

  initialize() {
    this.appConfig = this.appConfigService.getConfig();
  }

  set(
    name: string,
    value: string,
    expires = this.appConfig.cookieDaysToLive,
    path = '/',
    secure = location.protocol.indexOf('https') === 0,
    domain?: string,

  ): void {
    if (!domain) {
      domain = this.getTopLevelDomain(window.location.hostname);
    }
    this.cookieService.set(name, value, expires, path, domain, secure, 'Lax');
  }

  get(name: string): string {
    return this.cookieService.get(name);
  }

  check(name: string): boolean {
    return this.cookieService.check(name);
  }

  delete(name: string, path = '/', domain?: string) {
    if (!domain) {
      domain = this.getTopLevelDomain(window.location.hostname);
    }
    return this.cookieService.delete(name, path, domain);
  }

  private getTopLevelDomain(hostname: string) {
    const separator = hostname.indexOf('.');
    return hostname.substring(separator);
  }
}
